const getters = {
    delivery: (state) => state.delivery,
    deliveryid: (state) => state.deliveryid,
    item: (state) => state.item,
    itemid: (state) => state.itemid,
    status: (state) => state.status,
    signature: (state) => state.signature,
    signatureid: (state) => state.signatureid,
    loading: state => state.loading
};

export default getters;